import { useState, useEffect } from 'react';
import { isEqual } from 'lodash';
import { Breakpoints } from 'src/types/breakpoints.enum';

export interface ScreenBreakpoints {
    isMinWidthSmall: boolean;
    isMinWidthMedium: boolean;
    isMinWidthLarge: boolean;
    isMinWidthExtraLarge: boolean;
    isCustomMinWidth?: boolean;
}

/*
 * Get reactive width of screen relative to our breakpoints
 * Returns for each breakpoint whether current window is larger than breakpoint
 * Allows custom breakpoint to be passed in
 */
export const useBreakpoints = (customBreakpoint?: number): ScreenBreakpoints => {
    const getUpdatedScreenBreakpointState = (): ScreenBreakpoints => {
        const windowWidth = window.innerWidth;
        return {
            isMinWidthSmall: windowWidth >= Breakpoints.SMALL,
            isMinWidthMedium: windowWidth >= Breakpoints.MEDIUM,
            isMinWidthLarge: windowWidth >= Breakpoints.LARGE,
            isMinWidthExtraLarge: windowWidth >= Breakpoints.EXTRA_LARGE,
            isCustomMinWidth: windowWidth >= customBreakpoint
        };
    };

    const [screenBreakpoints, setScreenBreakpoints] = useState<ScreenBreakpoints>(getUpdatedScreenBreakpointState());

    const handleResize = (): void => {
        setScreenBreakpoints((prevState: ScreenBreakpoints): ScreenBreakpoints => {
            const updatedState = getUpdatedScreenBreakpointState();
            if (!isEqual(prevState, updatedState)) return updatedState;
            return prevState;
        });
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return screenBreakpoints;
};
